import adminAxiosInstance from "./api/adminAxiosInstance";

const getPlatformInfo = async () => {
  const response = await adminAxiosInstance.get("admin/platform-info");
  return response.data;
};

const getMonthlyReport = async (date) => {
  const formattedDate = date.toISOString().slice(0, 10);
  const response = await adminAxiosInstance.get(
    `admin/monthly-report?date=${formattedDate}`
  );
  return response.data;
};

export const platformService = {
  getPlatformInfo,
  getMonthlyReport,
};
